import { css } from 'linaria';

export const stageCardsTitle = css`
  margin-bottom: 32px;  

  @media (--to-largeDesktop) {
    font-size: 21px;
    font-weight: 600;
    line-height: 26px;
  }

  @media (--only-mobile) {
    margin-bottom: 24px;
  }
`;

export const stageCardsContainer = css`
  display: flex;
  column-gap: 16px;
  width: 100%;

  @media (--only-mobile) {
    flex-direction: column;
    row-gap: 16px;
  }
`;

export const stageCard = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 12px;
  padding: 20px;
  border-radius: var(--rounding-xl);
  background-color: var(--background-secondary);
  flex: 1;

  @media (--to-desktop) {
    row-gap: 32px;
  }
`;

export const stageCardTitleWrapper = css`
  display: flex;
  margin-bottom: 12px;

  @media (--only-largeDesktop) {
    align-items: center;
    column-gap: 12px;
  }

  @media (--to-largeDesktop) {
    flex-direction: column-reverse;
    row-gap: 12px;
  }
`;

export const stageCardLabel = css`
  background-color: var(--control-accent);
  padding: 4px 12px;
  border-radius: var(--rounding-circular);
  width: fit-content;
`;
